import { render, staticRenderFns } from "./ProjectTaskAssignedNotification.vue?vue&type=template&id=13997061"
import script from "./ProjectTaskAssignedNotification.vue?vue&type=script&lang=js"
export * from "./ProjectTaskAssignedNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports